import cookie from "react-cookies";
import CryptoJS from "crypto-js";

const SECRET_KEY = process.env.REACT_APP_CRYPTO_SECRET_KEY || "7tgjy7v8i6by9ob7";

export default class EncryptedCookieGateway {
  static set(key, value, options = {}) {
    try {
      if (value === undefined || value === null) {
        return;
      }
      const data = typeof value === "string" ? value : JSON.stringify(value);
      const encryptedValue = CryptoJS.AES.encrypt(data, SECRET_KEY).toString();

      cookie.save(key, encryptedValue, { path: "/", ...options });
    } catch (error) {
      console.error("Error setting encrypted cookie:", error);
    }
  }

  static get(key) {
    try {
      const encryptedValue = cookie.load(key);
      if (!encryptedValue) return null;

      const bytes = CryptoJS.AES.decrypt(encryptedValue, SECRET_KEY);
      if (!bytes || bytes.sigBytes <= 0) {
        cookie.remove(key, { path: "/" });
        window.dispatchEvent(new CustomEvent("invalid_cookie_detected"));
        return null;
      }
      const decrypted = bytes.toString(CryptoJS.enc.Utf8);

      if (!decrypted) return null;
      const trimmed = decrypted.trim();
      if (/[\x00-\x08\x0B\x0C\x0E-\x1F]/.test(trimmed)) {
        cookie.remove(key, { path: "/" });
        window.dispatchEvent(new CustomEvent("invalid_cookie_detected"));
        return null;
      }
      const firstChar = trimmed[0];
      if (firstChar === "{" || firstChar === "[") {
        try {
          return JSON.parse(trimmed);
        } catch {
          return decrypted;
        }
      }

      // Everything else is returned as-is (string), including:
      // "true", "false", "null", "123", "hello", etc.
      return decrypted;
    } catch (error) {
      console.error("Error reading encrypted cookie:", error);
      return null;
    }
  }

  static remove(key, options = {}) {
    try {
      cookie.remove(key, { path: "/", ...options });
    } catch (error) {
      console.error("Error removing encrypted cookie:", error);
    }
  }
}
